var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMenu = function SvgMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 20 16",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.417 1.155A1.024 1.024 0 0 1 1.444.128h17.113a1.027 1.027 0 1 1 0 2.054H1.444A1.024 1.024 0 0 1 .417 1.155ZM.417 8a1.024 1.024 0 0 1 1.027-1.027h17.113a1.027 1.027 0 1 1 0 2.054H1.444A1.024 1.024 0 0 1 .417 8Zm19.167 6.845a1.023 1.023 0 0 1-1.027 1.027H1.444a1.027 1.027 0 1 1 0-2.054h17.113a1.023 1.023 0 0 1 1.027 1.027Z"
  })));
};
export default SvgMenu;